import { find } from 'lodash/fp';
import React, { ReactNode, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useAppConfig } from '../context';
import {
  RouteOverlayLocationState,
  RouteOverlayParams,
  RouteOverlayType,
} from './route-overlays.types';
import { getBackgroundPath } from './route-overlays.utils';

export interface RouteOverlayLinkProps extends RouteOverlayParams {
  overlayType: RouteOverlayType;
  children?: ReactNode;
}

export function RouteOverlayLink({
  children,
  entityId,
  overlayType,
  pathParams = [],
  backgroundPath,
}: RouteOverlayLinkProps) {
  const { routes } = useAppConfig();
  const location = useLocation<RouteOverlayLocationState>();

  const routesCollection =
    overlayType === 'modal' ? routes?.routeModals : routes?.routePanels;

  const route = find((route) => route.id === entityId, routesCollection);

  const calculateBackgroundPath = useMemo(
    () => backgroundPath || getBackgroundPath(location, route?.backgroundPath),
    [backgroundPath, location, route?.backgroundPath]
  );

  if (!route) return null;

  return (
    <Link
      to={{
        pathname: route.generatePath(pathParams),
        state: {
          routeOverlay: {
            entityId,
            path: route.path,
            backgroundPath: calculateBackgroundPath,
          },
        } as RouteOverlayLocationState,
      }}
    >
      {children}
    </Link>
  );
}
